import { useTranslation } from "react-i18next";
import { parseHtml } from "@components/HTMLParser/utils";
import { useConfirmKnowYourCustomerMutation } from "@services/knowYourCustomer/mutations";
import {
  KycFormStep,
  type TKnowYourCustomerStepAction,
} from "@services/knowYourCustomer/types";
import { KYCModalActionButtons } from "../KYCModalActionButtons/KYCModalActionButtons";
import { KYCModalPaging } from "../KYCModalPaging/KYCModalPaging";

interface IConfirmationFormProps {
  onChangeStep: (step: KycFormStep) => void;
}

export const ConfirmationForm: React.FC<IConfirmationFormProps> = ({
  onChangeStep,
}) => {
  const { t } = useTranslation();

  const { mutateAsync: confirmKnowYourCustomer, isPending } =
    useConfirmKnowYourCustomerMutation();

  const confirmKnowYourCustomerForm = async (
    step: TKnowYourCustomerStepAction,
  ) => {
    await confirmKnowYourCustomer(step).then((response) =>
      onChangeStep(response.currentForm),
    );
  };

  return (
    <div className="flex flex-col gap-6">
      <KYCModalPaging
        currentStep={KycFormStep.CONFIRMATION_FORM}
        onPreviousButtonClick={() => confirmKnowYourCustomerForm("previous")}
        onNextButtonClick={() => confirmKnowYourCustomerForm("next")}
        isLoading={isPending}
      />
      <p className="text-gray-900 p-0 text-lg font-semibold">
        {t("KYC.modal.confirm.title")}
      </p>
      <p className="text-sm text-grey-dark">
        {parseHtml(t("KYC.modal.confirm.description"))}
      </p>
      <KYCModalActionButtons
        onCancel={() => confirmKnowYourCustomerForm("close")}
        onSubmit={() => confirmKnowYourCustomerForm("next")}
        isLoading={isPending}
      />
    </div>
  );
};
